<template>
    <div class="container watermanPromo" style="padding-bottom: 2em;">
        <div class="row">
            <div class="col-md-12" v-html="content"></div>
            <div class="col-md-12">
                <router-link v-for="button in buttons" :key="button.key" class="btn btn-purple" :to="button.path">{{ button.name }}</router-link>
            </div>
        </div>
    </div>
</template>

<script>
    var marked = require("marked")
    marked.setOptions({
        headerIds: false
    });

    import content from '../pages_content/watermanPromo.md';

    export default {
        name: 'WatermanPromo',
        data() {
            return {
                content: this.md(content),
                buttons: [
                //    { name:"Подробнее о системе Ватерман", path:"/products/waterman3"}
                ]
            }
        },
        methods: {
            md: function(val){
                return marked(val);
            }
        },

    }
</script>

<style scoped>
    .container {
        margin-top: 115px;
    }
    .block_button_1 {
        text-align: left!important;
    }
    .block_button_2 {
        text-align: right!important;
    }
    @media (max-width: 767px) {
        .block_button_2 {
            text-align: left!important;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/pages/WatermanPromo.vue